import React from 'react';
import './Technical.scss';

function Technical(props) {

  const modalToggler = (code, name) => {
    props.modalToggler("download", code, name)
  }

  const GAEvent = (event) => {
    if (document.location.hostname.indexOf("flex.basler.com") > -1) {
      window.gtag('event', event)
    }
  }

  let bulletin1 = <a onClick={() => GAEvent('BE1-FLEX Bulletin, English')} download href={process.env.PUBLIC_URL + "/Assets/Documents/BE1-FLEX-UUB-EN.pdf"}>BE1-FLEX Bulletin, English</a>
  let bulletin2 = <a onClick={() => GAEvent('BE1-FLEX Bulletin, Spanish')} download href={process.env.PUBLIC_URL + "/Assets/Documents/BE1-FLEX-UUB-Spanish.pdf"}>BE1-FLEX Bulletin, Spanish</a>
  let bulletin3 = <a onClick={() => GAEvent('BE1-FLEX Bulletin, Chinese')} download href={process.env.PUBLIC_URL + "/Assets/Documents/BE1-FLEX-UUB-Chinese.pdf"}>BE1-FLEX Bulletin, Chinese</a>
  let youtube = <a onClick={() => GAEvent('Youtube page')} href="https://www.youtube.com/playlist?list=PLlRokf4uBcT-wqX1Wso2bgnQhXV4ZhMqs">Youtube page</a>
  let product = <a onClick={() => GAEvent('BE1-Flex product page')} href="https://www.basler.com/Product/BE1-FLEX">BE1-FLEX product page</a>
  if (props.windowSize === "Web") {
    bulletin1 = <a onClick={() => GAEvent('BE1-FLEX Bulletin, English')} target="_blank" rel="noreferrer" href={process.env.PUBLIC_URL + "/Assets/Documents/BE1-FLEX-UUB-EN.pdf"}>BE1-FLEX Bulletin, English</a>
    bulletin2 = <a onClick={() => GAEvent('BE1-FLEX Bulletin, Spanish')} target="_blank" rel="noreferrer" href={process.env.PUBLIC_URL + "/Assets/Documents/BE1-FLEX-UUB-Spanish.pdf"}>BE1-FLEX Bulletin, Spanish</a>
    bulletin3 = <a onClick={() => GAEvent('BE1-FLEX Bulletin, Chinese')} target="_blank" rel="noreferrer" href={process.env.PUBLIC_URL + "/Assets/Documents/BE1-FLEX-UUB-Chinese.pdf"}>BE1-FLEX Bulletin, Chinese</a>
    youtube = <a onClick={() => GAEvent('Youtube page')} target="_blank" rel="noreferrer" href="https://www.youtube.com/playlist?list=PLlRokf4uBcT-wqX1Wso2bgnQhXV4ZhMqs">Youtube page</a>
    product = <a onClick={() => GAEvent('BE1-Flex product page')} target="_blank" rel="noreferrer" href="https://www.basler.com/Product/BE1-FLEX">BE1-FLEX product page</a>
  }

  return (
    <div className={'Technical ' + props.windowSize}>
      <div className="technical-container">
        <h2>
          Technical Resources
        </h2>
        <h3>Instruction Manuals</h3>
        <ul>
          <li><button onClick={() => modalToggler("zaWrudrEthu2HOtRifiFRlMOw","BE1-FLEX Instruction Manual, Rev F, English")}>BE1-FLEX Instruction Manual, English</button></li>
          <li><button onClick={() => modalToggler("2inl4isWadowiQ9ph4kAxikih","BE1-FLEX Instruction Manual, Rev F Spanish")}>BE1-FLEX Instruction Manual, Spanish</button></li>
          <li><button onClick={() => modalToggler("X9THOzOtaCojijlTruwa5riFr","BE1-FLEX Instruction Manual, Rev F, Chinese")}>BE1-FLEX Instruction Manual, Chinese</button></li>
        </ul>
        <h3>Protocol Manuals</h3>
        <ul>
          <li><button onClick={() => modalToggler("Dr2pubOSpIx5ni5LHEbLQewrA","BE1-FLEX Communication Integration Manual, Rev A, English")}>BE1-FLEX Communication Integration Manual, English</button></li>
          <li><button onClick={() => modalToggler("r9P9us7sTlwiwIte7hocruCH7","BE1-FLEX Communication Integration Manual, Rev A, Spanish")}>BE1-FLEX Communication Integration Manual, Spanish</button></li>
          <li><button onClick={() => modalToggler("eSlzlQhLhIcucL5ragifRoZeW","BE1-FLEX Communication Integration Manual, Rev A, Chinese")}>BE1-FLEX Communication Integration Manual, Chinese</button></li>
        </ul>
        
        <h3>Product Bulletins</h3>
        <ul>
          <li>{bulletin1}</li>
          <li>{bulletin2}</li>
          <li>{bulletin3}</li>
        </ul>
        <h3>Brochures</h3>
        <ul>
          <li><button onClick={() => modalToggler("fRlzlPhLhIcucL4ragifRoYeW","Brochure: Power Systems Solutions - Proven Worldwide")}>Brochure: Power Systems Solutions - Proven Worldwide</button></li>
        </ul>
        <h3>Videos</h3>
        <ul>
          <li>Check out BE1-FLEX highlights and tutorials on our {youtube}.</li>
        </ul>
        <h3>Want more information on the BE1-FLEX?</h3>
        <p>You can find all available resources on the {product}. Please note that an account will be required.</p>
      </div> 
    </div>
  );
}

export default Technical;